<template>
  <div>

    <!-- 导航组件封装 -->
    <Navigation></Navigation>
    <div class="container-xl top" >
      <div class="row">
        <div class="indicator"> 
          <div :class="Previous > 1 ? 'Change1' : ''" class="schedule1"><div :class="Previous > 1 ? 'point3' : ''" class="point2"></div></div>
          <div style="width: 9%;" :class="Previous == 2 ? 'Change' : (Previous > 2 ? 'Change3' : '') "  class="schedule"><div :class="Previous == 2 ? 'point1' : (Previous > 2 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 3 ? 'Change' : (Previous > 3 ? 'Change3' : '')" class="schedule"><div :class="Previous == 3 ? 'point1' : (Previous > 3 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 4 ? 'Change' : (Previous > 4 ? 'Change3' : '')" class="schedule"><div :class="Previous == 4 ? 'point1' : (Previous > 4 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 5 ? 'Change' : (Previous > 5 ? 'Change3' : '')" class="schedule"><div :class="Previous == 5 ? 'point1' : (Previous > 5 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 6 ? 'Change' : (Previous > 6 ? 'Change3' : '')" class="schedule"><div :class="Previous == 6 ? 'point1' : (Previous > 6 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 7 ? 'Change' : (Previous > 7 ? 'Change3' : '')" class="schedule"><div :class="Previous == 7 ? 'point1' : (Previous > 7 ? 'point3' : '')" class="point"></div></div>
          <div :class="Previous == 8 ? 'Change' : (Previous > 8 ? 'Change3' : '')" class="schedule"><div :class="Previous == 8 ? 'point1' : (Previous > 8 ? 'point3' : '')" class="point"></div></div>
          <!-- <div :class="Previous == 9 ? 'Change' : (Previous > 9 ? 'Change3' : '')" class="schedule"><div :class="Previous == 9 ? 'point1' : (Previous > 9 ? 'point3' : '')" class="point"></div></div> -->
        </div>
        <div class="swipea">
        <van-swipe  class="my-swipe"  :loop="false" :autoplay="-1" ref="swipe" :touchable="false"  :show-indicators="false">
          <van-swipe-item >
            <div class="assessment-button">
              <img src="../img/icon2x.png" alt=""><br>
              <h3>欢迎来到 <span style="font-family: Omnium-ExtraBold">be@me</span></h3>
              <p>30秒测试， <br> 看看隐形矫正适不适合你</p>
              <button  class="jump" @click="start()">
                立即开始
              </button>
            </div>
          </van-swipe-item>

          <van-swipe-item>
            <div class="Why">
              <h3>你为什么想矫正牙齿？</h3>
              <button @click="one(1)" :class="QuestionOne == '1' ? 'fengqi' : ''">
                没有佩戴保持器，二次矫正</button
              ><br />
              <button @click="one(2)" :class="QuestionOne == '2' ? 'fengqi' : ''">
                我的牙齿不好看（有明显的牙齿问题）</button
              ><br />
              <button @click="one(3)" :class="QuestionOne == '3' ? 'fengqi' : ''">
                牙齿已经影响到我的健康问题</button
              ><br />
              <button @click="one(4)" :class="QuestionOne == '4' ? 'fengqi' : ''">
                准备参加聚会
              </button>
              <div>
                <button v-if="QuestionOne != ''" class="jump" @click="start()"> 下一题 </button>
              </div>
              
            </div>
          </van-swipe-item>

          <van-swipe-item>
            <div class="whether">
              <h3>你曾经佩戴过牙套吗？</h3>
              <button @click="two(1)" :class="QuestionTwo == '1' ? 'fengqi' : ''">
                是
              </button><br>
              <button @click="two(2)" :class="QuestionTwo == '2' ? 'fengqi' : ''">
                否
              </button>
              <div>
                <button v-if="QuestionTwo != ''" class="jump" @click="start()"> 下一题 </button>
              </div>
          </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="worry">
              <h3>你的牙齿拥挤情况如何？</h3>
              <div class="level" @click="three(1)" :class="QuestionThree == '1' ? 'fengqi' : ''"><img src="../img/1轻度与无拥挤.gif" alt=""><p>轻度或无拥挤</p></div>
              <div class="level" @click="three(2)" :class="QuestionThree == '2' ? 'fengqi' : ''"><img src="../img/2中度拥挤.gif" alt=""><p>中度拥挤</p></div>
              <div class="level" @click="three(3)" :class="QuestionThree == '3' ? 'fengqi' : ''"><img src="../img/3中度加.gif" alt=""><p>中度+</p></div>
              <div>
                <button v-if="QuestionThree != ''" class="jump" @click="start()"> 下一题 </button>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="worry">
              <h3>你的牙缝情况如何？</h3>         
              <div class="level" @click="four(1)" :class="QuestionFour == '1' ? 'fengqi' : ''"><img src="../img/1轻度牙缝间隙.gif" alt=""><p>轻度或无间隙</p></div>
              <div class="level" @click="four(2)" :class="QuestionFour == '2' ? 'fengqi' : ''"><img src="../img/2中度牙缝问题.gif" alt=""><p>中度</p></div>
              <div class="level" @click="four(3)" :class="QuestionFour == '3' ? 'fengqi' : ''"><img src="../img/3中度加牙缝问题.gif" alt=""><p>中度+</p></div>
              <div>
                <button v-if="QuestionFour != ''" class="jump" @click="start()"> 下一题 </button>
              </div>
            </div>
          </van-swipe-item>
          <!-- <van-swipe-item>
            <div class="data">
              <h3>请留下你的电邮地址</h3>
              <h4>我们会通过邮箱分享你的结论以及<br>有关牙齿矫正的相关资讯及最新疗程优惠</h4>
              <el-input v-model="mail" placeholder="您的邮箱"></el-input>
              <div>
                <button  class="jump" @click="kap1()">继续</button>
              </div>
            </div>
          </van-swipe-item> -->
          <van-swipe-item>
            <div class="whether">
              <h3>您现在有以下情况吗？</h3>
              <button @click="five(1)" :class="QuestionFive == '1' ? 'fengqi' : ''">
                目前正怀孕或有计划怀孕
              </button><br>
              <button @click="five(2)" :class="QuestionFive == '2' ? 'fengqi' : ''">
                乳齿还未更换
              </button><br>
              <button @click="five(3)" :class="QuestionFive == '3' ? 'fengqi' : ''">
                年龄12岁以下
              </button><br>
              <button @click="five(4)" :class="QuestionFive == '4' ? 'fengqi' : ''">
                以上皆无
              </button>
              <div>
                <button v-if="QuestionFive != ''" class="jump" @click="start()"> 下一题 </button>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="data">
              <h3>我们已基本知晓您的情况！</h3>
              <h4>请在下方输入您的具体联系方式，让我们为您制定更好的矫齿方案。<br>我们会通过电邮与您分享关于矫齿的相关知识及节日特惠活动。</h4>
              <el-input v-model="name" placeholder="您的名字"></el-input>
              <el-input v-model="Phone" placeholder="您的电话号码"></el-input>
              <p >
                <input type="checkbox" checked="checked"></input>我同意接收 be@me 发送的相关资讯。
              </p>
              <div>
                <button  class="jump"@click="kap2()">获得结果</button>
              </div>
              
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div v-if="QuestionFive == '4' " class="data-success">
                <img src="../img/steps2x2.png" alt="" />
                <h3>
                  您好，<br> be@me团队已对您的牙齿情况做出初步审核！<br />
                  初步判断结果： <br>
                  您的牙齿情况适宜做be@me隐形矫正。
                </h3>
                <router-link to="/about"
                  ><button >立即预约免费3D口扫</button></router-link
                ><br />
            </div>
            <div v-else class="data-success">
                <img src="../img/steps2x2.png" alt="" />
                <h3>
                  您的牙齿情况不适合做 be@me 隐形矫正<br />
                  感谢您对我们的信任，<br>
                  be@me 还有很多相关牙齿护理产品。 <br>
                  欢迎您来关注， be@me的instagram  <br>
                  账号：my_beame，<br>
                  我们将不定时为您推送产品优惠信息及活动。
                </h3>
                <router-link to="/"><button>回到首页</button></router-link>
            </div>
          </van-swipe-item>      
        </van-swipe>
        </div>
        <p v-if="Previous == 1 || Previous==8"></p>
        <button v-else @click="back()">< 返回</button>
      </div>
    </div>
    <!-- 底部组件封装 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation.vue";
import Bottom from "@/components/Bottom.vue";
import { wxSubmitQuestionnaire, intoQuestionnairePage } from "@/api/outpatient";
export default {
  metaInfo: {
    link: [
      {
        rel: "canonical",
        href: "https://mybeame.com/test",
      },
      {
        rel: "alternate",
        href: "https://mybeame.com/test",
        hrefLang: "x-default",
      },
    ],
  },
  components: {
    Navigation,
    Bottom,
  },
  data() {
    return {
      name: "",
      mail: "",
      Phone: "",

      QuestionOne: "",
      QuestionTwo: "",
      QuestionThree: "",
      QuestionFour: "",
      QuestionFive: "",
      uresData: {},
      Previous: 1,
      fbqEventId: new Date().getTime(),
    };
  },
  mounted() {
    var uresData = {
      fbqEventId: this.fbqEventId,
    };
    intoQuestionnairePage(uresData).then((res) => {
      //网页浏览量接口
    });
  },
  methods: {
    //轮播返回上一页事件

    back: function (event) {
      this.$refs.swipe.prev();
      if (this.Previous == 1) {
        return;
      } else {
        this.Previous -= 1;
      }
    },

    //点击赋值 按钮变色  轮播切换下一页
    start() {
      // debugger;
      this.$refs.swipe.next();
      this.Previous += 1;
    },
    one(QuestionOne) {
      this.QuestionOne = QuestionOne;
    },
    two(QuestionTwo) {
      this.QuestionTwo = QuestionTwo;
    },
    three(QuestionThree) {
      this.QuestionThree = QuestionThree;
    },
    four(QuestionFour) {
      this.QuestionFour = QuestionFour;
    },
    five(QuestionFive) {
      this.QuestionFive = QuestionFive;
    },
    six(QuestionSix) {
      this.QuestionSix = QuestionSix;
    },

    //发送请求事件
    // kap1() {
    //   if (
    //     /^([a-zA-Z0-9_\.\-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(
    //       this.mail
    //     ) == false
    //   ) {
    //     this.$message({
    //       message: "请填写正确邮箱",
    //       type: "warning",
    //     });
    //     return;
    //   }
    //   this.active = 6;
    //   var uresData = {
    //     question_1: this.QuestionOne,
    //     question_2: this.QuestionTwo,
    //     question_3: this.QuestionThree,
    //     question_4: this.QuestionFour,
    //     email: this.mail,
    //     fbqEventId: this.fbqEventId,
    //   };
    //   submitQuestionnaire(uresData).then((res) => {
    //     this.Previous += 1;
    //     this.$refs.swipe.next();
    //   });
    // },
    //发送请求事件
    kap2() {
      if (this.name == "") {
        this.$message({
          message: "请填写姓名",
          type: "warning",
        });
        return;
      }
      if (/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.Phone) == false) {
        this.$message({
          message: "请填写正确电话号码",
          type: "warning",
        });
        return;
      }
      var uresData = {
        question_1: this.QuestionOne,
        question_2: this.QuestionTwo,
        question_3: this.QuestionThree,
        question_4: this.QuestionFour,
        question_5: this.QuestionFive,
        name: this.name,
        phone: this.Phone,
        remark: "网页",
      };
      wxSubmitQuestionnaire(uresData).then((res) => {
        if (res.code == 200) {
          this.Previous += 1;
          this.$refs.swipe.next();
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}
.top {
  margin-top: 70px;
}

.row {
  margin-left: 0;
  margin-right: 0;
}
.row > button {
  text-align: center;
  font-size: 21px;
  font-weight: 600;
  border: none;
  margin-bottom: 20px;
  background-color: #f9f9f9;
}
.test {
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background-color: #f9f9f9;
}
.swipea {
  text-align: center;
  height: 600px;
  background-color: #f9f9f9;
}
.swipea > p {
  margin: 10px 0 0 0;
  font-weight: 700;
  font-size: 19px;
}
.my-swipe .van-swipe-item {
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.assessment > h2 {
  margin: 0 auto;
  font-size: 28px;
  margin-bottom: 10px;
}
.assessment > p {
  padding: 10px 0;
  margin: 0 auto;
  margin-bottom: 55px;
}
.assessment-button > h3 {
  font-size: 35px;
  margin-bottom: 20px;
  color: #323e48;
}
.assessment-button {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}
.assessment-button > img {
  width: 10%;
  margin: 50px 0 25px 0;
  border-radius: 35px;
}
.assessment-button > p {
  color: #323e48;
  font-size: 21px;
}

.jump {
  width: 35%;
  height: 48px;
  border: none;
  color: #323e48;
  font-weight: 700;
  font-size: 21px;
  /* margin-top: 40px; */
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 30px;
  margin-top: 30px;
}
.Why {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}
.Why > h3 {
  font-size: 29px;
  margin-bottom: 30px;
  color: #323e48;
}

.Why > button {
  width: 40%;
  height: 48px;
  color: #323e48;
  margin-bottom: 30px;
  font-size: 19px;
  background: #ffffff;
  border: none;
  border-radius: 8px;
  /* box-shadow: 0px 4px 4px 0px rgba(0,228,103,0.10);  */
  box-shadow: 0px 0px 8px 0px rgba(0, 228, 103, 0.1);
}
.whether {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}

.whether > h3 {
  font-size: 29px;
  margin-bottom: 30px;
  color: #323e48;
}

.whether > button {
  width: 40%;
  height: 48px;
  color: #323e48;
  margin-bottom: 30px;
  font-size: 19px;
  background: #ffffff;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px rgba(0, 228, 103, 0.1);
}
.worry {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}
.worry > h3 {
  font-size: 29px;
  margin-bottom: 30px;
  color: #323e48;
}

.level {
  width: 23%;
  /* height: 80px; */
  margin: 0 auto;
  margin-top: 20px;
  background: #fcfcfd;
  border-radius: 8px;
  font-size: 14px;
  box-shadow: 0px 0px 8px 0px rgba(0, 228, 103, 0.1);
}
.level > img {
  width: 70%;
  border-radius: 8px;
}
.level > p {
  color: #323e48;
  margin-top: -18px;
  padding-bottom: 5px;
  background-color: #fcfcfd;
  border-radius: 8px;
}
.data {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}
.data > h3 {
  font-size: 29px;
  margin-bottom: 30px;
  color: #323e48;
}
.data > h4 {
  color: #323e48;
  font-size: 17px;
  margin-bottom: 25px;
}
.data > p {
  color: #323e48;
  font-size: 16px;
  margin-top: 90px;
  margin-bottom: 10px;
}
.data >>> .el-input__inner {
  width: 40%;
  height: 48px;
  margin-bottom: 20px;
  background: #ffffff;
  border: 2px solid #00e467;
  border-radius: 8px;
}
.data > p > input {
  margin-right: 5px;
}

.fengqi {
  color: #323e48 !important;
  border: 1px solid #00e467 !important;
  box-shadow: 0px 4px 4px 0px rgba(0, 228, 103, 0.1) !important;
}
.data-success {
  width: 100%;
  height: 600px;
  padding: 50px 0;
  margin: 0 auto;
  text-align: center;
  border-radius: 15px;
}
.data-success > img {
  width: 10%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.data-success > h3 {
  font-size: 16px;
  margin-bottom: 20px;
  color: #323e48;
  line-height: 30px;
}
.data-success > a > button {
  width: 35%;
  height: 48px;
  border: none;
  font-weight: 700;
  color: #323e48 !important;
  margin-top: 40px;
  font-size: 16px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 20px 0px 0px;
}
.navigation {
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px 0;
}
.logo {
  width: 40%;
  margin-left: 1%;
}
.my {
  display: flex;
  align-items: center;
  width: 30%;
  text-align: center;
}
.my > img {
  width: 45%;
  margin-right: 5px;
  margin-left: 15%;
}
.my > span {
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
}
.menu {
  width: 30%;
  padding-right: 10px;
}

.logo > a > img {
  width: 55%;
  padding-top: 4px;
}

.van-dialog {
  text-align: center;
}
.van-dropdown-menu {
  text-align: left;
  float: right;
}

.indicator {
  display: flex;
  align-items: center;
  padding: 20px 5%;
  background-color: #f9f9f9;
}
.schedule1 {
  width: 7%;
  height: 10px;
  padding: 1px 1px;
  background: #00e467;
  border-radius: 20px 20px 20px 20px;
}
.schedule {
  width: 13%;
  height: 10px;
  padding: 1px 1px;
  border-radius: 20px 20px 20px 20px;
}
.Change1 {
  background: #00e467;
  border-radius: 20px 0px 0px 20px !important;
}
.Change {
  background: #00e467;
  border-radius: 0px 20px 20px 0px !important;
}
.Change3 {
  background: #00e467 !important;
  border-radius: 0px 0px 0px 0px !important;
}
.point1 {
  background-color: #fff !important;
}
.point3 {
  background: #99f4c2 !important;
}
.point {
  width: 8px;
  height: 8px;
  float: right;
  border-radius: 20px 20px 20px 20px;
  background-color: #00e467;
}
.point2 {
  width: 8px;
  height: 8px;
  float: left;
  border-radius: 20px 20px 20px 20px;
  background-color: #fff;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
}
@media all and (max-width: 770px) {
  .top {
    margin-top: 44px;
  }
  .assessment-button > h3 {
    font-size: 26px;
  }
  .assessment-button > p {
    font-size: 19px;
  }
  .jump {
    width: 45%;
    font-size: 19px;
  }
  .Why > h3 {
    font-size: 26px;
  }
  .Why > button {
    width: 50%;
    font-size: 17px;
  }
  .whether > h3 {
    font-size: 26px;
  }
  .whether > button {
    width: 50%;
  }
  .worry > h3 {
    font-size: 26px;
  }
  .level {
    width: 35%;
    font-size: 12px;
  }
  .level > img {
    width: 80%;
  }
  .data > h3 {
    font-size: 26px;
  }
  .data > h4 {
    font-size: 16px;
  }
  .data >>> .el-input__inner {
    width: 50%;
    margin-bottom: 30px;
  }
  .data > p {
    margin-top: 70px;
  }
  .data-success > a > button {
    width: 40%;
  }
}
@media all and (max-width: 560px) {
  .van-swipe {
    height: 500px;
  }
  .swipea {
    height: 500px;
  }
  .assessment-button {
    height: 500px;
  }
  .assessment-button > img {
    width: 20%;
    margin: 0px 0 20px 0;
  }
  .assessment-button > h3 {
    font-size: 21px;
  }
  .assessment-button > p {
    font-size: 17px;
  }
  .jump {
    width: 70%;
    font-size: 17px;
    height: 42px;
    margin-top: 15px;
  }
  .Why {
    height: 500px;
  }
  .Why > h3 {
    font-size: 21px;
  }
  .Why > button {
    width: 80%;
    font-size: 14px;
    height: 42px;
    margin-bottom: 20px;
  }
  .whether {
    height: 500px;
  }
  .whether > h3 {
    font-size: 21px;
  }
  .whether > button {
    width: 80%;
    font-size: 14px;
    height: 42px;
    margin-bottom: 20px;
  }
  .worry {
    height: 500px;
  }
  .worry > h3 {
    font-size: 21px;
  }
  .level {
    width: 50%;
    font-size: 12px;
  }
  .level > img {
    width: 100%;
  }
  .data {
    height: 500px;
  }
  .data > h3 {
    font-size: 21px;
  }
  .data > h4 {
    font-size: 14px;
    padding: 0 10%;
  }
  .data >>> .el-input__inner {
    width: 80%;
    margin-bottom: 20px;
    height: 40px;
  }
  .data > p {
    margin-top: 20px;
  }
  .data-success > a > button {
    width: 60%;
  }
  .data-success > img {
    width: 20%;
  }
  .data-success > h3 {
    font-size: 15px;
    line-height: 25px;
  }
  .row > button{
    font-size: 18px;
  }
}
</style>